// Mock data for HAAS Mosaic corporate website (frontend-only preview)
// Real images sourced from www.mosaic.haas.tr

const UP = "/mosaic";

export const LOGO = "/mosaic/2021/08/haas-logo.png";

export const CONTACT = {
  brand: "HAAS MOSAIC",
  brandSub: "Antioch Arts",
  phone: "+90 850 303 44 40",
  phoneTel: "+908503034440",
  whatsapp: "905455154448",
  whatsappDisplay: "+90 545 515 44 48",
  email: "mosaic@haas.tr",
  addressEn: "Antakya, Hatay — Türkiye",
  addressTr: "Antakya, Hatay — Türkiye",
  instagram: "https://www.instagram.com/haas_mosaic?igsh=MXd6MjNidHEyOHNhbQ==",
  youtube: "https://youtube.com/@haas_mosaic?si=oARfDbwjzdocqjAv",
  facebook: "https://www.facebook.com/haasmosaic?mibextid=wwXIfr&mibextid=wwXIfr",
};

// Global offices — Türkiye is HQ (merkez)
export const OFFICES = [
  { code: "tr", region: "Antakya, Hatay — Türkiye", phone: "+90 850 303 44 40", phoneTel: "+908503034440", email: "mosaic@haas.tr", hq: true },
  { code: "ca", region: "Toronto, ON — Canada", phone: "+1 437 339 1611", phoneTel: "+14373391611", email: "mark.y.coskun@haasmosaic.ca" },
  { code: "us", region: "Washington, DC — USA", phone: "+1 202 596 5726", phoneTel: "+12025965726", email: "hello@haasmosaic.us" },
  { code: "it", region: "Premariacco, Udine — Italy", phone: "+39 375 615 2361", phoneTel: "+393756152361", email: "hello@haasmosaic.it" },
  { code: "gr", region: "Trikorfo, Fokidos — Greece", phone: "+30 697 373 6426", phoneTel: "+306973736426", email: "hello@haasmosaic.gr" },
];

// Product categories (exactly mirroring mosaic.haas.tr)
export const categories = [
  {
    slug: "portrate",
    name: { en: "Portrate", tr: "Portre" },
    tagline: { en: "The most demanding form of art", tr: "Sanatın en zorlu biçimi" },
    desc: {
      en: "Portrait mosaic, the most challenging branch of mosaic art, comes to life through the mastery of our experienced artisans. In this unique field, we craft nothing less than the finest and most exquisite expressions of art.",
      tr: "Mozaik sanatının en zorlu dalı olan portre mozaiği, deneyimli ustalarımızın maharetiyle hayat bulur. Bu eşsiz alanda, sanatın en incelikli ve en zarif ifadelerini üretiyoruz.",
    },
    image: `${UP}/2025/08/Adsiz-tasarim-27.png`,
  },
  {
    slug: "mithology",
    name: { en: "Mithology", tr: "Mitoloji" },
    tagline: { en: "Legends in stone, immortality in mosaic", tr: "Taşta efsaneler, mozaikte ölümsüzlük" },
    desc: {
      en: "The legends of antiquity are reborn in the timeless beauty of stone. Depicting gods, heroes, and mythological scenes, our mosaics bring the grandeur of the past into the present with unmatched artistry.",
      tr: "Antik çağın efsaneleri, taşın zamansız güzelliğinde yeniden doğar. Tanrıları, kahramanları ve mitolojik sahneleri betimleyen mozaiklerimiz, geçmişin ihtişamını eşsiz bir ustalıkla bugüne taşır.",
    },
    image: `${UP}/2025/08/Adsiz-tasarim-12.jpg`,
  },
  {
    slug: "3d-art",
    name: { en: "3D Art", tr: "3D Sanat" },
    tagline: { en: "Beyond the surface, into the dimension of art", tr: "Yüzeyin ötesinde, sanatın boyutunda" },
    desc: {
      en: "We combine the delicacy of small tesserae with the grandeur of larger stones. Through the mastery of depth, shadow, and light, our mosaics transcend the surface to create striking dimensionality.",
      tr: "Küçük tesseraların inceliğini büyük taşların ihtişamıyla birleştiriyoruz. Derinlik, gölge ve ışık ustalığıyla mozaiklerimiz yüzeyi aşarak çarpıcı bir boyut kazanır.",
    },
    image: `${UP}/2025/08/Adsiz-tasarim-13.jpg`,
  },
  {
    slug: "wall-art",
    name: { en: "Wall Art", tr: "Duvar Sanatı" },
    tagline: { en: "Timeless artistry on your walls", tr: "Duvarlarınızda zamansız sanat" },
    desc: {
      en: "Mosaic is not merely a covering, but a statement of identity for spaces. Crafted by the hands of master artisans, our mosaics transform walls into timeless works of art.",
      tr: "Mozaik yalnızca bir kaplama değil, mekânların kimlik beyanıdır. Usta zanaatkârların elinden çıkan mozaiklerimiz, duvarları zamansız sanat eserlerine dönüştürür.",
    },
    image: `${UP}/2025/08/Adsiz-tasarim-14.jpg`,
  },
  {
    slug: "floor-art",
    name: { en: "Floor Art", tr: "Zemin Sanatı" },
    tagline: { en: "Art beneath every step", tr: "Her adımın altında sanat" },
    desc: {
      en: "Mosaic floors offer not only durability, but also timeless elegance. With intricate patterns crafted by our master artisans, each floor becomes a striking centerpiece.",
      tr: "Mozaik zeminler yalnızca dayanıklılık değil, zamansız bir zarafet de sunar. Usta zanaatkârlarımızın işlediği karmaşık desenlerle her zemin çarpıcı bir merkez unsuru olur.",
    },
    image: `${UP}/2025/08/Adsiz-tasarim-15.jpg`,
  },
  {
    slug: "pool-art",
    name: { en: "Pool Art", tr: "Havuz Sanatı" },
    tagline: { en: "Elegance that comes alive in your pool", tr: "Havuzunuzda hayat bulan zarafet" },
    desc: {
      en: "Where water meets stone, mosaic art reaches a new dimension. Our masterfully crafted pool mosaics bring serenity and elegance to spaces, enhanced by the play of light and water.",
      tr: "Suyun taşla buluştuğu yerde mozaik sanatı yeni bir boyuta ulaşır. Ustalıkla işlenmiş havuz mozaiklerimiz, ışık ve suyun oyunuyla mekânlara huzur ve zarafet katar.",
    },
    image: `${UP}/2025/08/Adsiz-tasarim-16.jpg`,
  },
  {
    slug: "tiles",
    name: { en: "Tiles", tr: "Karolar" },
    tagline: { en: "Small pieces, magnificent art", tr: "Küçük parçalar, muhteşem sanat" },
    desc: {
      en: "Each tile is born from the union of art and craftsmanship. Expertly crafted, our mosaic tiles bring elegance and character to walls and floors alike.",
      tr: "Her karo, sanat ve zanaatın birleşiminden doğar. Ustaca işlenen mozaik karolarımız, hem duvarlara hem zeminlere zarafet ve karakter katar.",
    },
    image: `${UP}/2025/08/Adsiz-tasarim-17.jpg`,
  },
  {
    slug: "raw-stones",
    name: { en: "Raw Stones", tr: "Ham Taşlar" },
    tagline: { en: "Nature's beauty, transformed into art", tr: "Doğanın güzelliği, sanata dönüşür" },
    desc: {
      en: "Our raw stones, processed in their natural form, serve as the foundation of artistic expression. Each stone, with its unique texture and color, fuels creativity and elegance in mosaic.",
      tr: "Doğal formunda işlenen ham taşlarımız, sanatsal ifadenin temelini oluşturur. Her taş, kendine özgü dokusu ve rengiyle mozaikte yaratıcılığı ve zarafeti besler.",
    },
    image: `${UP}/2025/08/Adsiz-tasarim-18.jpg`,
  },
];

export const products = [
  // Portrate
  { id: "p1", slug: "mustafa-kemal-ataturk", name: "Mustafa Kemal Atatürk", category: "portrate", image: `${UP}/2025/10/7A6F4227-8A6B-439E-8186-916BAB3877E9-760x760.png` },
  { id: "p2", slug: "the-pearl-earing-girl", name: "The Pearl Earing Girl", category: "portrate", image: `${UP}/2025/10/1A87069D-4758-42ED-AB8F-4DCBD190B3B9-300x300.jpeg` },
  { id: "p3", slug: "symphony-of-stone", name: "Symphony of Stone", category: "portrate", image: `${UP}/2025/10/IMG_0278-300x300.jpg` },
  { id: "p4", slug: "silent-gaze", name: "Silent Gaze", category: "portrate", image: `${UP}/2025/10/01fd77cb-c414-4cea-aa85-9eed4ed69ef2.jpg-300x300.jpg` },
  { id: "p5", slug: "the-half-faced-muse", name: "The Half-Faced Muse", category: "portrate", image: `${UP}/2025/10/DD652CC8-A56C-4DB0-AA51-87CE56353E2C-300x300.png` },
  { id: "p6", slug: "echo-of-her-soul", name: "Echo of Her Soul", category: "portrate", image: `${UP}/2025/10/F8BCD93C-42B4-4319-962D-C888AFE3D86F_1_105_c-e1761762360665-320x320.jpeg` },
  { id: "p7", slug: "inner-woman", name: "Inner Woman", category: "portrate", image: `${UP}/2025/10/7a1fcea7-e5cb-4c3d-9cd3-b99f3d34fce4.jpg-300x300.jpg` },
  { id: "p8", slug: "golden-tears", name: "Golden Tears", category: "portrate", image: `${UP}/2025/10/0015d007-9c45-491a-b607-549449cd75cd.jpg-300x300.jpg` },
  // Mithology
  { id: "m1", slug: "be-cheerful-enjoy-your-life", name: "Be Cheerful – Enjoy Your Life", category: "mithology", image: `${UP}/2025/10/IMG_0665-300x300.jpg` },
  { id: "m2", slug: "evil-eye", name: "Evil Eye", category: "mithology", image: `${UP}/2025/10/78d36c13-0c0c-4ebf-97b6-646d43b40a27-300x300.jpg` },
  { id: "m3", slug: "oceanus-and-tethys", name: "Oceanus and Tethys", category: "mithology", image: `${UP}/2025/10/6a6319ab-d875-4f0a-8b9c-c762f0aced67-300x300.jpg` },
  { id: "m4", slug: "warrior-mosaic-spirit-of-alexander", name: "Warrior Mosaic – Spirit of Alexander", category: "mithology", image: `${UP}/2025/10/c3d6d4a8-bea6-4c9b-bd23-4bef9dcf9b3c-300x300.jpg` },
  // 3D Art
  { id: "d1", slug: "3d-olive-tree", name: "3D Olive Tree", category: "3d-art", image: `${UP}/2025/10/IMG_3463-2-300x300.jpg` },
  { id: "d2", slug: "biblos-resort-alacati", name: "Biblos Resort Alaçatı", category: "3d-art", image: `${UP}/2025/10/15994D0B-84C8-4A55-AE7F-0BF43CB84358_1_102_o-300x300.jpeg` },
  // Wall Art
  { id: "w1", slug: "the-wild-majesty-tiger", name: "The Wild Majesty – Tiger", category: "wall-art", image: `${UP}/2025/10/bcf443e6-63c0-498a-ab86-7dc9f0fcaa26-300x300.jpeg` },
  { id: "w2", slug: "natures-harmony", name: "Nature's Harmony", category: "wall-art", image: `${UP}/2025/10/1615c75f-b6ac-4353-b289-785d504893d4-300x300.jpeg` },
  { id: "w3", slug: "majestic-elegance-the-peacock", name: "Majestic Elegance – The Peacock", category: "wall-art", image: `${UP}/2025/10/0fc61dba-d976-47ef-b1c3-da946e65e5fc-300x300.jpg` },
  { id: "w4", slug: "blooms-in-deep-tones", name: "Blooms in Deep Tones", category: "wall-art", image: `${UP}/2025/10/a474a904-381f-41bc-a8b2-20e5a92c18cc-300x300.jpg` },
  // Floor Art (category showcase images used as representative works)
  { id: "f1", slug: "geometric-floor-medallion", name: "Geometric Floor Medallion", category: "floor-art", image: `${UP}/2025/08/Adsiz-tasarim-15.jpg` },
  { id: "f2", slug: "roman-floor-pattern", name: "Roman Floor Pattern", category: "floor-art", image: `${UP}/2025/08/Adsiz-tasarim-24.png` },
  // Pool Art
  { id: "pa1", slug: "azure-pool-mosaic", name: "Azure Pool Mosaic", category: "pool-art", image: `${UP}/2025/08/Adsiz-tasarim-16.jpg` },
  { id: "pa2", slug: "peacock-pool-medallion", name: "Peacock Pool Medallion", category: "pool-art", image: `${UP}/2025/08/tavus.jpeg` },
  // Tiles
  { id: "t1", slug: "handmade-tessera-tiles", name: "Handmade Tessera Tiles", category: "tiles", image: `${UP}/2025/08/Adsiz-tasarim-17.jpg` },
  { id: "t2", slug: "classic-border-tiles", name: "Classic Border Tiles", category: "tiles", image: `${UP}/2025/08/Adsiz-tasarim-25.png` },
  // Raw Stones
  { id: "r1", slug: "natural-marble-stones", name: "Natural Marble Stones", category: "raw-stones", image: `${UP}/2025/08/Adsiz-tasarim-18.jpg` },
  { id: "r2", slug: "quarry-blocks", name: "Quarry Marble Blocks", category: "raw-stones", image: `${UP}/2025/08/Adsiz-tasarim-26.png` },
];

// Home hero slides — 8 slides covering all categories (mirrors "Choose Your Style")
export const heroSlides = categories.map((c) => ({
  image: c.image,
  kicker: { en: "HAAS MOSAIC", tr: "HAAS MOZAİK" },
  title: c.tagline,
  text: c.desc,
  categoryName: c.name,
  link: `/product-category/${c.slug}`,
}));

// How We Do — 8 step process
export const processSteps = [
  { image: `${UP}/2025/08/1.jpeg`, title: { en: "Raw Material Sourcing", tr: "Ham Madde Temini" }, subtitle: { en: "From the Heart of the Mountains", tr: "Dağların Kalbinden" }, text: { en: "The journey begins with the extraction of massive marble blocks—each weighing between 80 and 100 tons—from quarries nestled deep in the mountains.", tr: "Yolculuk, dağların derinliklerindeki ocaklardan her biri 80 ila 100 ton ağırlığındaki devasa mermer blokların çıkarılmasıyla başlar." } },
  { image: `${UP}/2025/08/2.png`, title: { en: "Sustainable Selection", tr: "Sürdürülebilir Seçim" }, subtitle: { en: "Valuing the Scraps", tr: "Artıkları Değerlendirmek" }, text: { en: "Instead of discarding valuable processing residues, we carefully select and repurpose them, turning what is often overlooked into the foundation of high-end mosaic art.", tr: "Değerli işleme artıklarını atmak yerine, özenle seçip yeniden değerlendiriyor; çoğu zaman göz ardı edileni üst düzey mozaik sanatının temeline dönüştürüyoruz." } },
  { image: `${UP}/2025/08/3-1.jpg`, title: { en: "Primary Shaping", tr: "İlk Şekillendirme" }, subtitle: { en: "Precision Cutting", tr: "Hassas Kesim" }, text: { en: "Using diamond-blade water-cooled cutting machines, our team slices the stones into thin slabs and then into small uniform sticks known as 'pen stones'.", tr: "Elmas bıçaklı su soğutmalı kesim makineleriyle ekibimiz taşları ince plakalara, ardından 'kalem taşlar' denilen küçük ve düzgün çubuklara ayırır." } },
  { image: `${UP}/2025/08/4.png`, title: { en: "Artistic Sorting", tr: "Sanatsal Ayrım" }, subtitle: { en: "Color and Texture Matching", tr: "Renk ve Doku Eşleştirme" }, text: { en: "The stones are sorted manually by color, pattern, and tonal quality to prepare for seamless color blending and gradient transitions.", tr: "Taşlar; renk, desen ve ton kalitesine göre elle ayrılır; kusursuz renk geçişleri ve harmanlamalar için hazırlanır." } },
  { image: `${UP}/2025/08/5.png`, title: { en: "Hand Crafting", tr: "El İşçiliği" }, subtitle: { en: "The Artisan's Touch", tr: "Zanaatkârın Dokunuşu" }, text: { en: "Each mosaic tile is individually shaped by hand using traditional mosaic tools to create the desired curves, edges, and details.", tr: "Her mozaik parçası, geleneksel mozaik aletleriyle elde tek tek şekillendirilerek istenen kıvrımlar, kenarlar ve detaylar oluşturulur." } },
  { image: `${UP}/2025/08/6.png`, title: { en: "Assembly", tr: "Montaj" }, subtitle: { en: "From Pieces to Pattern", tr: "Parçalardan Desene" }, text: { en: "The shaped stones are arranged with millimetric precision, ensuring continuity in lines, rhythm in pattern, and cohesion in theme.", tr: "Şekillendirilen taşlar, çizgilerde süreklilik, desende ritim ve temada bütünlük sağlayacak biçimde milimetrik hassasiyetle yerleştirilir." } },
  { image: `${UP}/2025/08/7.png`, title: { en: "Finishing", tr: "Son İşlem" }, subtitle: { en: "Quality Control and Mounting", tr: "Kalite Kontrol ve Montaj" }, text: { en: "Each mosaic undergoes a thorough quality inspection ensuring no gaps, smooth color transitions, and a level, structurally sound surface.", tr: "Her mozaik; boşluk olmaması, yumuşak renk geçişleri ve düzgün, sağlam bir yüzey için titiz bir kalite denetiminden geçer." } },
  { image: `${UP}/2025/08/8.jpeg`, title: { en: "Presentation", tr: "Sunum" }, subtitle: { en: "From Workshop to the World", tr: "Atölyeden Dünyaya" }, text: { en: "The completed mosaic artwork is carefully packed and transported to its destination—homes, hotels, galleries, or public spaces around the world.", tr: "Tamamlanan mozaik eser özenle paketlenerek varış noktasına—dünyanın dört bir yanındaki evlere, otellere, galerilere veya kamusal alanlara—ulaştırılır." } },
];

// Projects (All Projects)
export const projects = [
  { id: "pr1", slug: "biblos-resort-alacati", name: "Biblos Resort Alaçatı", location: { en: "İzmir, Türkiye", tr: "İzmir, Türkiye" }, image: `${UP}/2025/10/15994D0B-84C8-4A55-AE7F-0BF43CB84358_1_102_o-300x300.jpeg` },
  { id: "pr2", slug: "peacock-pool", name: { en: "Peacock Pool Installation", tr: "Tavus Kuşu Havuz Uygulaması" }, location: { en: "Bodrum, Türkiye", tr: "Bodrum, Türkiye" }, image: `${UP}/2025/08/tavus.jpeg` },
  { id: "pr3", slug: "grand-hall-floor", name: { en: "Grand Hall Floor", tr: "Büyük Salon Zemini" }, location: { en: "Istanbul, Türkiye", tr: "İstanbul, Türkiye" }, image: `${UP}/2025/08/Adsiz-tasarim-24.png` },
  { id: "pr4", slug: "mythology-wall-mural", name: { en: "Mythology Wall Mural", tr: "Mitoloji Duvar Panosu" }, location: { en: "Antalya, Türkiye", tr: "Antalya, Türkiye" }, image: `${UP}/2025/08/Adsiz-tasarim-12.jpg` },
  { id: "pr5", slug: "olive-tree-lobby", name: { en: "Olive Tree Lobby", tr: "Zeytin Ağacı Lobisi" }, location: { en: "Çeşme, Türkiye", tr: "Çeşme, Türkiye" }, image: `${UP}/2025/10/IMG_3463-2-300x300.jpg` },
  { id: "pr6", slug: "villa-portrait", name: { en: "Private Villa Portrait", tr: "Özel Villa Portresi" }, location: { en: "Bebek, İstanbul", tr: "Bebek, İstanbul" }, image: `${UP}/2025/10/DD652CC8-A56C-4DB0-AA51-87CE56353E2C-300x300.png` },
];

// UI translations
export const t = {
  en: {
    nav: { home: "Home", shop: "Gallery", categories: "Collections", projects: "Projects", process: "How We Do", apply: "Application Guide", about: "About", heritage: "Heritage", info: "Info", contact: "Contact", contactInfo: "Contact Info", academy: "Academy" },
    priceOnRequest: "Price on request",
    quickView: "Quick View",
    discover: "Discover",
    viewAll: "View All",
    exploreCollections: "Explore Collections",
    getInTouch: "Get in Touch",
    contactUs: "Contact Us",
    requestQuote: "Request a Quote",
    ctaTitle: "Together, for tomorrow",
    ctaText: "Let us craft a timeless mosaic story for your space.",
    welcome: "Welcome to HAAS Antioch Arts",
    whereArt: "Where Art Meets Mastery",
    whereArtText: "We design and produce tesserae, transforming them into mosaics through a rare harmony of exquisite materials, refined craftsmanship, and distinctive production techniques.",
    letEnchant: "Let yourself be enchanted",
    chooseStyle: "Choose Your Style",
    howWeDo: "How We Do?",
    processIntro: "From the heart of the mountains to your space — every mosaic passes through eight meticulous stages of craftsmanship.",
    applyTitle: "How It's Applied to Your Spaces",
    applyIntro: "Watch our short step-by-step guides — press play and they run right here, without leaving the page.",
    applyFull: "View Full Guide",
    applyNeedHelp: "Need Help?",
    projectsIntro: "Spaces that embody the essence of those who live them — selected mosaic works from around the world.",
    products: "Products",
    allProjects: "All Projects",
    footerAbout: "We bring together stones shaped by nature over millions of years, refined by the delicate touch of master craftsmanship.",
    quickLinks: "Quick Links",
    collections: "Collections",
    contactForm: { name: "Your Name", email: "Your Email", phone: "Phone", message: "Your Message", send: "Send Message", sent: "Thank you! We will get back to you soon." },
    rights: "All rights reserved.",
    products_in: "works in this collection",
    backToShop: "Back to Shop",
    relatedWorks: "Related Works",
    inquire: "Inquire on WhatsApp",
  },
  tr: {
    nav: { home: "Ana Sayfa", shop: "Galeri", categories: "Koleksiyonlar", projects: "Projeler", process: "Nasıl Yapıyoruz", apply: "Nasıl Uygulanır", about: "Hakkımızda", heritage: "Tarihçe", info: "Bilgi", contact: "İletişim", contactInfo: "İletişim Bilgileri", academy: "Akademi" },
    priceOnRequest: "Fiyat için iletişime geçin",
    quickView: "Hızlı Bakış",
    discover: "Keşfet",
    viewAll: "Tümünü Gör",
    exploreCollections: "Koleksiyonları Keşfet",
    getInTouch: "İletişime Geçin",
    contactUs: "Bize Ulaşın",
    requestQuote: "Teklif İste",
    ctaTitle: "Yarınlara birlikte",
    ctaText: "Mekânınız için zamansız bir mozaik hikâyesi tasarlayalım.",
    welcome: "HAAS Antioch Arts'a Hoş Geldiniz",
    whereArt: "Sanatın Ustalıkla Buluştuğu Yer",
    whereArtText: "Tesseraları tasarlar ve üretir; onları eşsiz malzemeler, incelikli işçilik ve kendine özgü üretim teknikleriyle nadir bir uyum içinde mozaiklere dönüştürürüz.",
    letEnchant: "Kendinizi büyülenmeye bırakın",
    chooseStyle: "Tarzınızı Seçin",
    howWeDo: "Nasıl Yapıyoruz?",
    processIntro: "Dağların kalbinden mekânınıza — her mozaik, sekiz titiz zanaat aşamasından geçer.",
    applyTitle: "Mekânlarınıza Nasıl Uygulanır",
    applyIntro: "Kısa, adım adım rehber videolarımızı izleyin — oynat'a basın, sayfadan ayrılmadan hemen burada oynasın.",
    applyFull: "Tüm Rehberi Gör",
    applyNeedHelp: "Yardıma mı ihtiyacınız var?",
    projectsIntro: "Yaşayanların özünü yansıtan mekânlar — dünyanın dört bir yanından seçilmiş mozaik eserler.",
    products: "Ürünler",
    allProjects: "Tüm Projeler",
    footerAbout: "Milyonlarca yılda doğanın şekillendirdiği taşları, usta zanaatın ince dokunuşuyla bir araya getiriyoruz.",
    quickLinks: "Hızlı Bağlantılar",
    collections: "Koleksiyonlar",
    contactForm: { name: "Adınız", email: "E-posta", phone: "Telefon", message: "Mesajınız", send: "Mesaj Gönder", sent: "Teşekkürler! En kısa sürede size döneceğiz." },
    rights: "Tüm hakları saklıdır.",
    products_in: "koleksiyonundaki eserler",
    backToShop: "Mağazaya Dön",
    relatedWorks: "Benzer Eserler",
    inquire: "WhatsApp'tan Sor",
  },
};

// Application guide videos (YouTube) — TR & EN
export const APPLY_VIDEOS = [
  {
    code: "tr",
    id: "hDPnEfeLD20",
    title: "Haas Mozaik Uygulama Rehberi",
    langLabel: "Türkçe",
    intro: "Mozaiğinizi teslim aldığınızda aşağıdaki adımları izleyin:",
    steps: [
      "Paketi açıp rulo halindeki mozaiği serip ters çevirin.",
      "Birlikte gelen boru içindeki yedek kalem taşları saklayın.",
      "Arkasındaki koruma plastik naylonu sökün.",
      "Büyük parçalar kesilmiş gelecektir; kesiliş şeklini anlamanız için kesilme sahnesi videoda var. 100 cm ve altı mozaikleri kesmenize gerek yok.",
      "1–3 mm yapıştırıcı uygulayın. Zeminin düz olması şarttır (suyla etkilenmeyen zeminler olmalı; örneğin alçı veya MDF olmaz).",
      "Mozaiğin fileli kısmının yapıştırıcıyla birleşmesi gerekir; üstüne bastırın ve düzleyin.",
      "Derzlemeye geçebilirsiniz (duvar uygulamalarında derzi tercih etmeyebilirsiniz; duvarlarda derz şartı yoktur).",
      "Islak süngerle temizleyin ve kurumaya bırakın.",
      "Kuruduktan sonra vernik (pıspıs veya fırçayla) uygulayın; mat ya da parlak, tamamen sizin tercihiniz.",
    ],
    help: "Takıldığınız veya anlamadığınız aşamalarda online destek hattımıza videolu ya da fotoğraflı olarak WhatsApp üzerinden ulaşabilirsiniz: +90 545 515 4448",
  },
  {
    code: "en",
    id: "tJAs6krAG3E",
    title: "Mosaic Installation Guide",
    langLabel: "English",
    intro: "Instructions for unboxing and applying your mosaic. Upon receiving your mosaic, please follow these steps:",
    steps: [
      "Unpack and Flatten: Open the package, unroll the mosaic, and lay it flat upside down.",
      "Store Spare Stones: Keep the spare loose stones packed inside the cardboard tube in a safe place.",
      "Remove the Backing: Peel off the protective plastic film from the back of the mosaic.",
      "Size and Cutting: Larger pieces arrive pre-cut. Reference photos show you how they fit together. Mosaics 100 cm and under do not need to be cut.",
      "Prepare the Surface: Apply 1 to 3 mm of adhesive. The surface must be completely flat and resistant to water (do not use gypsum/plaster or MDF).",
      "Position the Mosaic: Press the mesh-backed side firmly into the adhesive and level it out.",
      "Grouting (Optional for Walls): You can now proceed to grout. Grouting is not mandatory for wall applications.",
      "Clean and Dry: Wipe down the surface with a damp sponge and leave it to dry.",
      "Finishing: Once dry, apply a varnish (matte or glossy, as you prefer) using a spray or a brush.",
    ],
    help: "Need help? If you have any questions or get stuck during any step, reach out to our online support via WhatsApp with photos or videos at +90 545 515 4448.",
  },
];
